
import { Component } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

import { BaseWidgetComponent } from '../../../../../shared/base.component';
import { PointOfInterest } from '../../map-overlay-outlet/map-overlay-outlet.component';

@Component({
    selector: 'map-range',
    template: `
<div class="map-range" widget [style.height]="(diameter * 20) + '%'" [style.width]="(diameter * 20) + '%'">
    <div class="range" [style.height]="(size * 100) + '%'" [style.width]="(size * 100) + '%'"
        [style.background-color]="context.data.bg_alpha || 'rgba(3, 169, 244, .54)'"
        [style.border-color]="context.data.bg || '#03A9F4'">
    </div>
    <div class="details" [style.bottom]="'calc(' + (size * 100 / 2) + '% + 0.75em)' | safestyle">
        {{ context.data.text }}
    </div>
</div>

`,
    styles: [`.map-range{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);height:100%;width:100%}.map-range *{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.range{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:100%;border:3px dashed #03a9f4;background-color:rgba(3,169,244,.54);-webkit-transition:height 50ms,width 50ms;transition:height 50ms,width 50ms;will-change:height,width;-webkit-animation:.3s ease-out enter;animation:.3s ease-out enter}.details{position:absolute;bottom:3em;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);background-color:#fff;padding:.5em .75em;border-radius:.2em;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);min-width:5em;white-space:nowrap;-webkit-transition:bottom .2s;transition:bottom .2s;text-align:center;-webkit-animation:.6s ease-out enter-delay;animation:.6s ease-out enter-delay}@-webkit-keyframes enter{0%{opacity:0}100%{opacity:1}}@keyframes enter{0%{opacity:0}100%{opacity:1}}@-webkit-keyframes enter-delay{0%,50%{-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%);opacity:0}100%{-webkit-transform:translate(-50%,0);transform:translate(-50%,0);opacity:1}}@keyframes enter-delay{0%,50%{-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%);opacity:0}100%{-webkit-transform:translate(-50%,0);transform:translate(-50%,0);opacity:1}}`],
    animations: [
        trigger('show', [
            transition(':enter', [ style({ opacity: 0 }), animate(300, style({ opacity: 1 })) ]),
            transition(':leave', [ style({ opacity: 1 }), animate(300, style({ opacity: 0 })) ]),
        ]),
    ],
})
export class MapRangeComponent extends BaseWidgetComponent {
    public size = 10;
    public diameter = 16;
    public context: PointOfInterest;

    constructor(context: PointOfInterest) {
        super();
        this.context = context;
        this.size = (context.data as any).size || 10;
        this.subs.obs.changes = context.listen.subscribe((scale) => {
            this.diameter = (scale || 1) * ((context.data as any).diameter || 16);
        });
    }
}
